import "../Styles/Services.css";
import { CircleCheck } from "lucide-react";
import { useLang } from "../i18n/useLang";
import { useRef, useState } from "react";

function ServicesSection() {
  const { t } = useLang();

  const baseCards = t.home.services.cards;
  const extraCards = t.home.services.extraCards;

  // ✅ Always show all services
  const displayedCards = [...baseCards, ...extraCards];

  // Drag-to-scroll
  const scrollerRef = useRef(null);
  const dragStateRef = useRef({
    isDown: false,
    startX: 0,
    startScrollLeft: 0,
    moved: false,
  });

  const [svDragging, setSvDragging] = useState(false);

  const onPointerDown = (e) => {
    const el = scrollerRef.current;
    if (!el) return;

    // Let interactive elements (links/buttons/inputs) handle their own clicks.
    if (e.target.closest("a,button,input,textarea,select,label")) return;

    if (e.pointerType === "mouse" && e.button !== 0) return;

    el.setPointerCapture?.(e.pointerId);

    dragStateRef.current.isDown = true;
    dragStateRef.current.startX = e.clientX;
    dragStateRef.current.startScrollLeft = el.scrollLeft;
    dragStateRef.current.moved = false;

    setSvDragging(true);
  };

  const onPointerMove = (e) => {
    const el = scrollerRef.current;
    const s = dragStateRef.current;
    if (!el || !s.isDown) return;

    const dx = e.clientX - s.startX;
    if (Math.abs(dx) > 4) s.moved = true;

    el.scrollLeft = s.startScrollLeft - dx;
  };

  const endDrag = () => {
    dragStateRef.current.isDown = false;
    setSvDragging(false);
  };

  const onClickCapture = (e) => {
    if (dragStateRef.current.moved) {
      e.preventDefault();
      e.stopPropagation();
      dragStateRef.current.moved = false;
    }
  };

  return (
    <div className="sv" aria-label="Services section">
      <h2 className="sv-title">
        {t.home.services.titleLine1} <br /> {t.home.services.titleLine2}
      </h2>

      <p className="sv-subtitle">
        {t.home.services.subtitleLine1} <br /> {t.home.services.subtitleLine2}
      </p>

      <div
        ref={scrollerRef}
        className={`CardsCont ${svDragging ? "svDragging" : ""}`}
        onPointerDown={onPointerDown}
        onPointerMove={onPointerMove}
        onPointerUp={endDrag}
        onPointerCancel={endDrag}
        onPointerLeave={endDrag}
        onClickCapture={onClickCapture}
        role="list"
        aria-label="Service cards"
      >
        {displayedCards.map((card) => (
          <div
            className="cardSV"
            key={card.id}
            data-variant={card.variant}
            role="listitem"
          >
            <div className="cardright">
              <h3 className="sv-cardTitle">{card.title}</h3>

              <div className="sv-points">
                {card.points.map((pt, idx) => (
                  <div className="textcont" key={`${card.id}-${idx}`}>
                    <CircleCheck
                      className="circlecheck"
                      aria-hidden="true"
                      focusable="false"
                    />
                    <span className="textSV">{pt}</span>
                  </div>
                ))}
              </div>

              <a className="SeeMoreBtn" href="#contact">
                {t.home.services.cardCta}
              </a>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default ServicesSection;
